<app-loading></app-loading>
<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <a class="navbar-brand" [routerLink]="['/home']" routerLinkActive="active">
    <img src="../assets/images/logo.png" alt="">
  </a>
  <button class="navbar-toggler custom-toggler" #showMenu type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse fs-16" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item" *ngIf="!isLoggedIn || (isLoggedIn && user.role[0].name === 'employer')">
        <a class="nav-link" (click)="clickShowMenu(showMenu)" [routerLink]="['/recruit']" routerLinkActive="active">{{ 'header.menu.recruit' | translate }}</a><div class="menu-border"></div>
      </li>
      <li class="nav-item">
        <a class="nav-link" (click)="clickShowMenu(showMenu)" [routerLink]="['/find-job']" routerLinkActive="active">{{ 'header.menu.findJob' | translate }}</a><div class="menu-border"></div>
      </li>
      <li class="nav-item">
        <a class="nav-link" (click)="clickShowMenu(showMenu)" [routerLink]="['/why-quickform']" routerLinkActive="active">{{ 'header.menu.whyQuickform' | translate }}</a><div class="menu-border"></div>
      </li>
      <li class="nav-item">
        <a class="nav-link" (click)="clickShowMenu(showMenu)" [routerLink]="['/discrimination']" routerLinkActive="active">{{ 'header.menu.objectivity' | translate }}</a><div class="menu-border"></div>
      </li>
    </ul>
    <ul class="navbar-nav my-2 my-lg-0">
      <li class="nav-item" *ngIf="!isLoggedIn"><a class="nav-link" (click)="clickShowMenu(showMenu)" [routerLink]="['/login']" routerLinkActive="active">{{ 'login.login' | translate }}</a><div class="menu-border"></div></li>
      <li class="nav-item" *ngIf="isLoggedIn" dropdown><a class="nav-link" dropdownToggle class="dropdown-toggle" style="padding: 15px 19px;">{{ user.email }}</a>
        <ul *dropdownMenu class="dropdown-menu" role="menu">
          <li *ngIf="!isAdmin" role="menuitem"><a class="dropdown-item" (click)="clickShowMenu(showMenu)" [routerLink]="['/my-account']" href="#">{{ 'header.user.myAccount' | translate }}</a></li>
          <li *isAdminstrator role="menuitem"><a class="dropdown-item" (click)="clickShowMenu(showMenu)" [routerLink]="['/super-administrator/user-management']">{{ 'header.user.userManagement' | translate }}</a></li>
          <li *isAdminstrator role="menuitem"><a class="dropdown-item" (click)="clickShowMenu(showMenu)" [routerLink]="['/super-administrator/job-ad-management']">{{ 'header.user.jobAdManagement' | translate }}</a></li>
          <li *isAdminstrator role="menuitem"><a class="dropdown-item" (click)="clickShowMenu(showMenu)" [routerLink]="['/super-administrator/payment-management']">{{ 'header.user.paymentManagement' | translate }}</a></li>
          <li class="divider dropdown-divider"></li>
          <li role="menuitem"><a class="dropdown-item" (click)="clickShowMenu(showMenu)" (click)="logOut()">{{ 'header.user.logout' | translate }}</a>
          </li>
        </ul>
      </li>
      <li class="nav-item"><a class="nav-link" (click)="clickShowMenu(showMenu)" [routerLink]="['/about-us']" routerLinkActive="active">{{ 'header.menu.aboutUs' | translate }}</a><div class="menu-border"></div></li>
      <li class="nav-item"><a class="nav-link" (click)="clickShowMenu(showMenu)" [routerLink]="['/contact']" routerLinkActive="active">{{ 'header.menu.contact' | translate }}</a><div class="menu-border"></div></li>
      <li class="nav-item"><a class="nav-link icon-flag" (click)="onChangedLang('en')"><img class="img-circle" src="./assets/images/united-kingdom.png" alt=""></a></li>
      <li class="nav-item"><a class="nav-link icon-flag" (click)="onChangedLang('sv')"><img class="img-circle" src="./assets/images/sweden.png" alt=""></a></li>
    </ul>
  </div>
</nav>

<div style="background: #f6fbfd" id="body">
  <router-outlet *ngIf="userChecked"></router-outlet>
</div>

<div id="footer">
  <footer class="text-center bg-color">
    <div class="container-fluid">
      <div class="row row-line-height">
        <div class="m-auto d-flex">
          <p class="footer-text mx-3 my-3 py-1 text-center">{{ 'footer.footer-text1' | translate }}</p>
          <a routerLinkActive="active">
            <div class="mx-1 my-3"><svg-icon name="facebook-icon" [svgStyle]="svgStyle"></svg-icon></div>
          </a>
          <a routerLinkActive="active">
            <div class="mx-1 my-3"><svg-icon name="twitter-icon" [svgStyle]="svgStyle"></svg-icon></div>
          </a>
        </div>
        <div class="m-auto">
          <p class="footer-text my-3">{{'common.copyright' | translate}}</p>
        </div>
      </div>
    </div>
  </footer>
</div>
<!--<hr>-->
<!--<footer class="text-center">-->
<!--  <div class="container">-->
<!--    <div class="row">-->
<!--      <div class="col-xs-12">-->
<!--        <p>{{'common.copyright' | translate}}</p>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</footer>-->
